export default __webpack_public_path__ + "static/IN-8015_4-2mm_lense_day-42792ed8c3befe069a9b4590f11ce132.webp";